import React, { Component, ReactNode } from 'react';
import { query } from '@trlogic/client-js';
import { AuditLog, AuditLogType } from '../domain/rbac/RbacDomains';
import NavigationUtil from '../util/NavigationUtil';
import CustomTable, { CustomColumnProps } from './custom/CustomTable';
import CustomPaginator, { CustomPaginatorProps } from '../components/custom/CustomPaginator';
import ComponentName from '../constant/ComponentName';
import { AuditClient } from '../client/audit/AuditClient';
import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import moment from 'moment';
import { AuditLogText } from '../domain/audit/AuditLogText';
import CustomLoading from './custom/CustomLoading';
import _ from 'lodash';
import ComponentUtil from '../util/ComponentUtil';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import CustomTableContentWrapper from './custom/CustomTableContentWrapper';
import { AuditLogExportJob } from '../domain/job/JobDomain';
import JobService from '../service/JobService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import MessageUtil from '../util/MessageUtil';
import Icon from '../icons/Icon';
import ItemToolsMenu from './ItemToolsMenu';
import { Dialog } from 'primereact/dialog';
import ListService from '../service/ListService';
import {
  CustomFilter as FilterType,
  CustomFilterCategorical,
  CustomFilterDateSearch,
  CustomFilterFields,
  CustomFilterLiteralSearch,
} from '../domain/ui/FilterDomains';
import FilterUtil from '../util/FilterUtil';
import { dispatch, RootState } from '../redux/store';
import { changePageFilter } from '../redux/actions/PageActions';
import ValueFactory from '../util/ValueFactory';
import { BaseAccess } from '../../../server/src/lib/domain/access/BaseAccess';
import DataType from '../constant/DataType';
import { PageState } from '../redux/reducers/PageReducer';
import { connect } from 'react-redux';
import { changeCaseColumns, changeListDataLoading } from '../redux/actions/CaseActions';
import { setAttribute } from '../redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import { DataTableSortMeta } from 'primereact/datatable';
import LanguageUtil from '../util/LanguageUtil';
import and = query.and;
import eq = query.eq;
import QueryBuilder = query.QueryBuilder;
import neq = query.neq;
import empty = query.empty;
import Filter = query.Filter;
import Order = query.Order;

class ComponentAuditLog extends Component<Props, State> {
  public state: State = new State();

  private auditClient: AuditClient = GatewayContainer.getInstance().get(GatewayNames.AUDIT_CLIENT);
  private jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private listService: ListService = ServiceContainer.getInstance().get(ServiceNames.LIST);

  private allowedTypesForPreview = [
    AuditLogType.IMPORT,
    AuditLogType.CREATE,
    AuditLogType.UPDATE,
    AuditLogType.UNDEPLOY,
    AuditLogType.DEPLOY,
    AuditLogType.REDEPLOY,
    AuditLogType.VARIABLE_DELETE,
    AuditLogType.IMPORT_LIST_DATA,
    AuditLogType.ADD_LIST_DATA,
    AuditLogType.REMOVE_LIST_DATA,
    AuditLogType.UPDATE_LIST_DATA,
  ];

  private excludedComponentForPreview = [
    ComponentName.JOBS,
    ComponentName.CASE,
    ComponentName.ADMIN_USER,
    ComponentName.ADMIN_ROLE,
    ComponentName.ADMIN_GROUP,
    ComponentName.DASHBOARD,
    ComponentName.CHART,
    ComponentName.AI_MODEL,
  ];

  private excludedTypes = [
    AuditLogType.COMPONENT_USER_WORK,
    AuditLogType.PAGE_VIEW,
    AuditLogType.LOGIN,
    AuditLogType.ADD_CATEGORY_TO_CATEGORY,
    AuditLogType.ADD_ITEM_TO_CATEGORY,
    AuditLogType.SEND_TRANSACTION,
    AuditLogType.CASE_DATA_EXPORT,
    AuditLogType.MAKER_REQUEST,
    AuditLogType.MAKER_REQUEST_APPROVE,
    AuditLogType.MAKER_REQUEST_REJECT,
    AuditLogType.WATCHLIST_SEARCH_MANY,
    AuditLogType.WATCHLIST_SEARCH_ONE,

    AuditLogType.TEST,
    AuditLogType.CASE_CLOSE,
    AuditLogType.CASE_CLOSE_BULK,
    AuditLogType.CASE_BULK_ACTION,
    AuditLogType.CASE_ASSIGNEE,
    AuditLogType.CASE_UNASSIGMENT,
    AuditLogType.CASE_GO,
    AuditLogType.CASE_HOLD,
    AuditLogType.CASE_COMMENT,
    AuditLogType.CASE_COMMENT_EDIT,
    AuditLogType.CASE_COMMENT_DOMAIN,
    AuditLogType.CASE_COMMENT_EDIT_DOMAIN,
    AuditLogType.CASE_ATTACHMENT,
    AuditLogType.CASE_ATTACHMENT_DOMAIN,
    AuditLogType.CASE_TAGGED_FIELD,
    AuditLogType.ENTITY_UPDATE,
    AuditLogType.ENTITY_COMMENT,
    AuditLogType.ENTITY_COMMENT_EDIT,
    AuditLogType.COMPONENT_WORK,
    AuditLogType.COMPONENT_USER_THROW,
    AuditLogType.CASE_RUN_ACTION,
    AuditLogType.KYC_RUN_ACTION,
    AuditLogType.CATEGORY_UPDATE_NAME,
    AuditLogType.REMOVE_ITEM_FROM_CATEGORY,
    AuditLogType.ALERT_COMMENT,
    AuditLogType.TRANSACTION_DATA_EXPORT,
    AuditLogType.EXPORT,
    AuditLogType.AUDIT_LOG_EXPORT,
    AuditLogType.ALERT_EXPORT,
    AuditLogType.CASE_LOG_EXPORT,
    AuditLogType.LIST_DATA_EXPORT,
    AuditLogType.CASE_VARIABLE_PANEL_EXPORT,
    AuditLogType.CHART_EXPORT,
    AuditLogType.GRAPH_EXPORT,
    AuditLogType.ADMIN_AUDITS_EXPORT,
    AuditLogType.LOGIN_AUDITS_EXPORT,
    AuditLogType.CRA_RESULT_EXPORT,
    AuditLogType.MATCH_MANY_LOG_EXPORT,
    AuditLogType.MATCH_MANY_LOG_RESULT_EXPORT,
    AuditLogType.ACH_DATA_EXPORT,
  ];

  public render(): ReactNode {
    const { auditLogs, loading, rows, totalRecord, currentPage, detailRecord } = this.state;
    if (loading) {
      return <CustomLoading />;
    }

    return (
      <div className={`flex flex-col scrollable-editor-container overflow-y-scroll w-full h-full ${!this.props.isAdminPage && 'px-5'}`}>
        <div className={'flex w-full h-full flex-col gap-y-1'}>
          <ItemToolsMenu
            defaultFilterDisabled
            onChangeFilter={this.onChangeFilter}
            filter={this.state.filter}
            exportVisible={true}
            importVisible={false}
            exportFunc={() => this.onExport()}
            exportVisibleAlways={true}
            component={this.props.component}
          />
          <div className={'flex w-full h-full max-h-[calc(100dvh-360px)] overflow-scroll'}>
            <CustomTable
              value={auditLogs}
              columns={this.getColumns()}
              onSortChange={this.onSortChange}
              multiSortMeta={this.getOrder()}
              data-testid='audit_list'
            />
          </div>
        </div>
        <div className={'paginator'}>
          <CustomPaginator
            rows={rows}
            totalRecords={totalRecord}
            currentRecords={auditLogs.length}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
            onPageChange={this.onPageChange}
            currentPage={currentPage}
          />
        </div>
        <Dialog
          header={LanguageUtil.get({ id: 'components.audit.table.detail', defaultMessage: 'Detail' })}
          className={'w-[500px]'}
          visible={detailRecord != undefined}
          onHide={() => this.setState({ detailRecord: undefined })}
          dismissableMask
        >
          {detailRecord && (
            <div className={'flex flex-col gap-y-3 text-sm'} data-testid='audit_detail_content'>
              {this.getDetailItems(detailRecord).map((item, index) => (
                <div key={index} className={'flex flex-col gap-y-1 pb-2 border-b last:border-b-0'}>
                  {Object.entries(item).map(([key, value]) => (
                    <div key={key} className={'flex gap-x-2'}>
                      <span className={'font-semibold'}>{key}:</span>
                      <span className={'break-all'}>{value == undefined ? 'N/A' : String(value)}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </Dialog>
      </div>
    );
  }

  private fillBlanks = (item: Record<string, any>): Record<string, any> => {
    const result: Record<string, any> = {};
    Object.entries(item).forEach(([key, value]) => {
      const label = key === 'id' || key === '_id' ? 'Item ID' : key;
      result[label] = value == undefined || value === '' ? 'N/A' : value;
    });
    return result;
  };

  private getDetailItems = (record: AuditLog): Record<string, any>[] => {
    const data: any = record.document.data;
    if (data == undefined) return [];
    if (record.operation === AuditLogType.ADD_LIST_DATA) {
      const items: any[] = Array.isArray(data.data) ? data.data : [data.data];
      return items.filter((i) => i != undefined).map((i) => this.fillBlanks(i));
    }
    if (record.operation === AuditLogType.UPDATE_LIST_DATA) {
      const items: any[] = Array.isArray(data.data) ? data.data : [data.data];
      const changedFields: string[] | undefined = Array.isArray(data.changedFields) ? data.changedFields : undefined;
      return items
        .filter((i) => i != undefined)
        .map((i) => {
          // Older records (logged before this field existed) don't carry `changedFields` —
          // fall back to showing the full item, same as before this change shipped.
          if (changedFields == undefined) return this.fillBlanks(i);
          const picked: Record<string, any> = {};
          changedFields.forEach((field) => {
            if (field in i) picked[field] = i[field];
          });
          return this.fillBlanks(picked);
        });
    }
    if (record.operation === AuditLogType.REMOVE_LIST_DATA) {
      // Newer records carry the removed item's full fields (`data`); older ones only captured
      // the removed id(s) (`value`) — fall back to id-only display for those.
      if (Array.isArray(data.data) && data.data.length > 0) {
        return data.data.filter((i: any) => i != undefined).map((i: any) => this.fillBlanks(i));
      }
      const ids: any[] = data.type === 'batch' && Array.isArray(data.value) ? data.value : [data.value];
      return ids.filter((id) => id != undefined).map((id) => ({ Item: id }));
    }
    if (record.component === ComponentName.LIST && (record.operation === AuditLogType.CREATE || record.operation === AuditLogType.UPDATE)) {
      return this.getSchemaFieldChangeItems(data);
    }
    return [];
  };

  private getSchemaFieldChangeItems = (data: any): Record<string, any>[] => {
    const fieldChanges = data.fieldChanges;
    if (fieldChanges == undefined) return [];
    const toRow = (field: any, change: 'Created' | 'Updated' | 'Removed') => ({
      Field: field?.name,
      Change: change,
      Type: field?.type ?? 'N/A',
      Description: field?.description == undefined || field?.description === '' ? 'N/A' : field.description,
      'Created By': field?.createdBy ?? 'N/A',
    });
    const created: any[] = Array.isArray(fieldChanges.created) ? fieldChanges.created : [];
    const updated: any[] = Array.isArray(fieldChanges.updated) ? fieldChanges.updated : [];
    const removed: any[] = Array.isArray(fieldChanges.removed) ? fieldChanges.removed : [];
    return [
      ...created.map((f) => toRow(f, 'Created')),
      ...updated.map((f) => toRow(f, 'Updated')),
      ...removed.map((f) => toRow(f, 'Removed')),
    ];
  };

  public async componentDidMount() {
    const count: number = await this.getCount();
    this.setState({ totalRecord: count }, this.getAuditLogs);
    this.prepareFilterFields();
  }

  public async getAuditLogs() {
    const { component, documentName } = this.props;
    const { currentPage, rows, sorts } = this.state;
    this.setState({ loading: true });
    const endpoint = `audit_log_ui_${NavigationUtil.getTenant()}_*`;
    const filter = and(
      component != undefined ? eq('component.keyword', component) : empty(),
      documentName != undefined ? eq('document.id.keyword', documentName) : empty(),
      ...this.excludedTypes.map((type) => neq('operation.keyword', type)),
      this.state.filter,
      neq('component.keyword', ComponentName.ADMIN_USER),
      neq('component.keyword', ComponentName.ADMIN_ROLE),
      neq('component.keyword', ComponentName.ADMIN_GROUP),
      neq('component.keyword', ComponentName.JOBS),
      neq('username.keyword', 'SYSTEM'),
    );
    const audits: AuditLog[] = await this.auditClient.getComponentAudits((currentPage - 1) * rows, rows, endpoint, filter, sorts);
    const count = await this.getCount();
    this.setState({ auditLogs: audits, loading: false, totalRecord: count });
  }

  private getOrder = (): DataTableSortMeta[] => {
    const { sorts } = this.state;
    return sorts.map((s) => {
      return {
        field: s.field,
        order: s.operator == 'ASC' ? 1 : -1,
      } as DataTableSortMeta;
    });
  };

  protected onSortChange = (sorts: Order[]) => {
    this.setState({ sorts }, this.getAuditLogs);
  };

  protected onChangeFilter = async (filter: Filter) => {
    const isSame = _.isEqual(filter, this.state.filter);
    if (isSame) return;
    const count: number = await this.getCount();
    this.setState({ filter, currentPage: 1, totalRecord: count }, this.getAuditLogs);
  };

  private prepareFilterFields = async () => {
    const fields: CustomFilterFields[] = await FilterUtil.getAuditFields();
    dispatch(
      changePageFilter({
        filter: ValueFactory.initializeFilter(),
        items: fields,
      }),
    );
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    this.setState({ rows: event.rows, currentPage: event.page, loading: true }, this.getAuditLogs);
  };

  private addFilter = async (field: string, value: any, label: string, dataType: DataType, categorical: boolean = false) => {
    const { changePageFilter, page } = this.props;
    const filter: { filter: FilterType; items: CustomFilterFields[] } = page.filter;
    if (categorical) {
      filter.filter.fields.push({
        field: field,
        label: label,
        enabled: true,
        search: {
          type: 'CATEGORICAL',
          value: {
            values: [value],
          } as CustomFilterCategorical,
        },
      });
    } else {
      switch (dataType) {
        case DataType.STRING:
        case DataType.NUMBER:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'LITERAL',
              value: {
                properties: {
                  dataType: dataType,
                },
                operator: 'eq',
                value: value,
              } as CustomFilterLiteralSearch,
            },
          });
          break;
        case DataType.DATE:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'DATE',
              value: {
                startDate: {
                  label: moment(value).format('LLLL'),
                  value: value,
                  type: 'Absolute',
                },
                endDate: {
                  label: moment(value).format('LLLL'),
                  value: value,
                  type: 'Absolute',
                },
              } as CustomFilterDateSearch,
            },
          });
          break;
        case DataType.BOOLEAN:
          await this.addFilter(field, value, label, dataType, true);
          break;
        default:
          return;
      }
    }
    changePageFilter(filter);
    this.onChangeFilter(this.parseFilter());
  };

  private parseFilter = () => {
    const { page } = this.props;
    const {
      filter: { filter },
    }: { filter: { filter: FilterType } } = page;
    return FilterUtil.parse(filter);
  };

  private getCount = (): Promise<number> => {
    const { component, documentName } = this.props;
    const endpoint = `audit_log_ui_${NavigationUtil.getTenant()}_*`;
    const _query = query.QueryBuilder.select()
      .from(endpoint)
      .where(
        and(
          component != undefined ? eq('component.keyword', component) : empty(),
          documentName != undefined ? eq('document.id.keyword', documentName) : empty(),
          and(neq('operation.keyword', AuditLogType.COMPONENT_USER_WORK), neq('operation.keyword', AuditLogType.PAGE_VIEW)),
          this.state.filter,
          neq('username.keyword', 'SYSTEM'),
        ),
      )
      .build();
    return this.auditClient.getCount(_query);
  };

  private getColumns(): CustomColumnProps[] {
    const columns: CustomColumnProps[] = [
      {
        field: 'operation',
        header: LanguageUtil.get({ id: 'components.audit.table.operation', defaultMessage: 'Operation' }),
        align: 'left',
        filterable: true,
        copyable: true,
        onCopy: (e: AuditLog) => {
          return e.operation;
        },
        addFilter: (e: AuditLog) => {
          this.addFilter('operation', e.operation, 'Username', DataType.STRING);
        },
        body: (record: AuditLog) => (
          <div className={'ml-4 flex items-center text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={this.renderOperation(record.operation)} data-testid='audit_operation_text' />
          </div>
        ),
      },
      {
        field: 'username',
        header: LanguageUtil.get({ id: 'components.audit.table.username', defaultMessage: 'Username' }),
        filterable: true,
        copyable: true,
        onCopy: (e: AuditLog) => {
          return e.username;
        },
        addFilter: (e: AuditLog) => {
          this.addFilter('username', e.username, 'Username', DataType.STRING, true);
        },
        body: (record: AuditLog) => (
          <div className={'flex items-center text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={record.username} data-testid='audit_username_text' />
          </div>
        ),
      },
      {
        field: 'protocol',
        header: LanguageUtil.get({ id: 'components.audit.table.protocol', defaultMessage: 'Protocol' }),
        filterable: true,
        copyable: true,
        onCopy: (e: AuditLog) => e.protocol ?? '',
        addFilter: (e: AuditLog) => {
          if (e.protocol)
            this.addFilter(
              'protocol',
              e.protocol,
              LanguageUtil.get({ id: 'components.audit.table.protocol', defaultMessage: 'Protocol' }),
              DataType.STRING,
              true,
            );
        },
        body: (record: AuditLog) => (
          <div className={'flex items-center text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={record.protocol ?? '-'} data-testid='audit_protocol_text' />
          </div>
        ),
      },
      {
        field: 'port',
        header: LanguageUtil.get({ id: 'components.audit.table.port', defaultMessage: 'Port' }),
        filterable: true,
        copyable: true,
        onCopy: (e: AuditLog) => e.port?.toString() ?? '',
        addFilter: (e: AuditLog) => {
          if (e.port != undefined)
            this.addFilter('port', e.port, LanguageUtil.get({ id: 'components.audit.table.port', defaultMessage: 'Port' }), DataType.NUMBER);
        },
        body: (record: AuditLog) => (
          <div className={'flex items-center text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={record.port?.toString() ?? '-'} data-testid='audit_port_text' />
          </div>
        ),
      },
      {
        field: 'timestamp',
        header: LanguageUtil.get({ id: 'components.audit.table.timestamp', defaultMessage: 'Timestamp' }),
        filterable: true,
        copyable: true,
        onCopy: (e: AuditLog) => {
          return moment(e.timestamp).format('LLL');
        },
        addFilter: (e: AuditLog) => {
          this.addFilter('timestamp', e.timestamp, 'Timestamp', DataType.DATE);
        },
        body: (record: AuditLog) => (
          <div className={'flex items-center text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={moment(record.timestamp).format('LLL')} data-testid='audit_timestamp_text' />
          </div>
        ),
      },
    ];
    if (this.props.previewComponentDetail) {
      columns.splice(
        1,
        0,
        {
          field: 'component',
          header: LanguageUtil.get({ id: 'components.audit.table.component', defaultMessage: 'Component' }),
          className: 'w-1/5',
          copyable: true,
          filterable: true,
          onCopy: (e: AuditLog) => {
            return this.handleComponent(e.component);
          },
          addFilter: (e: AuditLog) => {
            this.addFilter('component', e.component, 'Component', DataType.STRING, true);
          },
          body: (record: AuditLog) => {
            const component = this.handleComponent(record.component);
            return (
              <div className={'flex items-center text-xs 2xl:text-md'}>
                <CustomTableContentWrapper text={component} data-testid='audit_component_text' />
              </div>
            );
          },
        },
        {
          field: 'Component Name',
          header: LanguageUtil.get({ id: 'components.audit.table.componentName', defaultMessage: 'ComponentName' }),
          className: 'max-w-[200px] truncate',
          copyable: true,
          filterable: true,
          onCopy: (record: AuditLog) => {
            const doc: BaseAccess = record.document.data as any as BaseAccess;
            return this.getLogDocumentId(doc);
          },
          addFilter: (e: AuditLog) => {
            this.addFilter('document.id', e.document.id, 'Component Name', DataType.STRING);
          },
          body: (record: AuditLog) => {
            const doc: BaseAccess = record.document.data as any as BaseAccess;
            const documentId = this.getLogDocumentId(doc);
            return (
              <div className={'flex items-center text-xs 2xl:text-md'}>
                <CustomTableContentWrapper clipSize={20} text={documentId?.toString() ?? ''} data-testid='audit_component_id_text' />
              </div>
            );
          },
        },
      );
    }
    columns.push({
      field: 'Detail',
      header: LanguageUtil.get({ id: 'components.audit.table.detail', defaultMessage: 'Detail' }),
      className: 'max-w-[90px] 2xl:max-w-[120px]',
      align: 'center',
      body: (record: AuditLog) => {
        if (!this.hasDetail(record)) {
          return <div className={'flex items-center justify-center text-xs 2xl:text-md'}>N/A</div>;
        }
        return (
          <div className={'flex items-center justify-center text-xs 2xl:text-md'}>
            <button
              onClick={() => this.setState({ detailRecord: record })}
              className={'text-[#458EF7] hover:underline'}
              data-testid='audit_detail_button'
            >
              {LanguageUtil.get({ id: 'components.audit.table.showDetail', defaultMessage: 'Show detail' })}
            </button>
          </div>
        );
      },
    });
    if (this.props.canPreview) {
      columns.push({
        field: 'Action',
        header: LanguageUtil.get({ id: 'components.audit.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[70px] 2xl:max-w-[100px]',
        align: 'center',
        body: (record: AuditLog) => {
          const allowed = this.canPreview(record);
          if (!allowed) return null;
          return (
            <div className={'flex items-center text-xs 2xl:text-md'}>
              <button onClick={() => this.goPreview(record)} className={'text-primary-500'} data-testid='audit_preview_button'>
                <Icon icon='eye' className={'text-primary'} size={20} />
              </button>
            </div>
          );
        },
      });
    }
    return columns;
  }

  // "Detail" column: a quick read-only look at the single item a list-data mutation audit
  // record refers to (the item that was created/removed), shown in a dialog.
  private itemDetailTypes = [AuditLogType.ADD_LIST_DATA, AuditLogType.REMOVE_LIST_DATA, AuditLogType.UPDATE_LIST_DATA];

  // A List's schema save (CREATE/UPDATE) only gets a "show detail" button when that particular
  // save actually changed fields — plain saves with no schema changes keep showing N/A.
  private hasDetail = (record: AuditLog): boolean => {
    if (this.itemDetailTypes.includes(record.operation)) return true;
    if (record.component === ComponentName.LIST && (record.operation === AuditLogType.CREATE || record.operation === AuditLogType.UPDATE)) {
      const data: any = record.document.data;
      const fieldChanges = data?.fieldChanges;
      if (fieldChanges == undefined) return false;
      const created = Array.isArray(fieldChanges.created) ? fieldChanges.created.length : 0;
      const updated = Array.isArray(fieldChanges.updated) ? fieldChanges.updated.length : 0;
      const removed = Array.isArray(fieldChanges.removed) ? fieldChanges.removed.length : 0;
      return created + updated + removed > 0;
    }
    return false;
  };

  private goPreview = async (record: AuditLog) => {
    // Open the tab synchronously, within the click's call stack — browsers block window.open()
    // calls made after an await (no longer a direct user-gesture), so it has to happen first and
    // get its URL assigned once the async lookup below resolves.
    const newTab = window.open('', '_blank');
    try {
      let document: any = record.document.data;
      if (document == undefined || typeof document != 'object') {
        console.error('Document is not valid', document);
        newTab?.close();
        return;
      }
      // List item mutation audits (create/update/remove item) don't carry the List's own
      // name/type — without it ComponentUtil.handleLink can't tell an internal list from an
      // external one and always falls back to the wrong (query/external) edit page.
      if (record.component === ComponentName.LIST && this.itemDetailTypes.includes(record.operation)) {
        const list = await this.listService.findById(record.document.id);
        if (list != undefined) {
          document = { name: list.name, type: list.type };
        }
      }
      const url = ComponentUtil.handleLink(record.component, record.document.id, document);
      if (url == undefined) {
        console.error('Url cannot be undefined');
        newTab?.close();
        return;
      }
      const parsedUrl = `${url}?preview=true&id=${record.id}`;
      if (newTab) {
        newTab.location.href = parsedUrl;
      } else {
        window.open(parsedUrl, '_blank');
      }
    } catch (e) {
      console.error(e);
      newTab?.close();
    }
  };

  private renderOperation = (operation: AuditLogType) => {
    return AuditLogText[operation] ?? operation;
  };

  private canPreview = (record: AuditLog) => {
    const { canPreview } = this.props;
    if (!canPreview) return;
    const type = record.operation;
    const component = record.component;
    return this.allowedTypesForPreview.includes(type) && !this.excludedComponentForPreview.includes(component);
  };

  private onExport = async () => {
    const { component, documentName } = this.props;
    const endpoint = `audit_log_ui_${NavigationUtil.getTenant()}_*`;
    const query = QueryBuilder.select()
      .from(endpoint)
      .where(
        and(
          component != undefined ? eq('component.keyword', component) : empty(),
          documentName != undefined ? eq('document.id.keyword', documentName) : empty(),
          and(neq('operation.keyword', AuditLogType.COMPONENT_USER_WORK), neq('operation.keyword', AuditLogType.PAGE_VIEW)),
          ...this.excludedTypes.map((type) => neq('operation.keyword', type)),
          this.state.filter,
          neq('username.keyword', 'SYSTEM'),
        ),
      )
      .build();
    const job: AuditLogExportJob = {
      type: 'AUDIT_LOG_EXPORT',
      timestamp: Date.now(),
      status: 'PENDING',
      query,
      userFilter: this.state.filter,
      representation: false,
      format: 'csv',
      extension: 'csv',
      path: '',
    };
    try {
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: 'Success',
        detail: 'Export job has been scheduled',
      });
    } catch (e) {}
  };

  private getLogDocumentId(doc: any) {
    if (doc.hasOwnProperty('request') && doc.request.documentId) {
      return doc.request.documentId;
    }
    if (doc?.type?.toLowerCase()?.includes('export')) return AuditLogText[doc.type as AuditLogType] ?? doc.type;
    return doc.id ?? doc._id;
  }

  private handleComponent(component: ComponentName) {
    switch (component) {
      case ComponentName.STREAM:
        return 'Store';
      default:
        return component;
    }
  }
}

interface Props extends FormicaProps, ReduxProps {
  component?: ComponentName;
  isAdminPage?: boolean;
  documentName?: string;
  canPreview?: boolean;
  previewComponentDetail?: boolean;
}

class State {
  loading: boolean = true;
  auditLogs: AuditLog[] = [];
  totalRecord: number = 0;
  rows: number = 20;
  currentPage: number = 1;
  filter: Filter = empty();
  sorts: Order[] = [{ field: 'timestamp', operator: 'DESC' }];
  detailRecord?: AuditLog = undefined;
}

const mapStateToProps = (state: RootState) => ({
  page: state.page as PageState,
});

const connector = connect(mapStateToProps, { changeCaseColumns, setAttribute, changeListDataLoading, changePageFilter });
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ComponentAuditLog));
